/**
 * Открыть заявки в контакты по тапу на пуш contact_request. С варианта A аудита 2026-10-04
 * это раздел «Заявки» экрана «Новое сообщение» (панели «дружина» больше нет); имена функций
 * остались прежними, чтобы не трогать места вызова.
 * Буферизует запрос, если ChatListScreen ещё не смонтирован (холодный старт): переходит туда он.
 */

type Listener = () => void;

let listener: Listener | null = null;
let pendingOpen = false;

export function requestOpenDruzhina(): void {
  if (listener) {
    listener();
    return;
  }
  pendingOpen = true;
}

export function subscribeOpenDruzhina(fn: Listener): () => void {
  listener = fn;
  if (pendingOpen) {
    pendingOpen = false;
    fn();
  }
  return () => {
    if (listener === fn) listener = null;
  };
}
